import { ShopResourceTypeScheduleMode } from '../../constants'
import type { Shop } from '../../types'
import { getDeliveryModelFromJourney } from '../getDeliveryModelFromJourney'

/**
 * Returns whether the shop uses CABIN_ONLY configuration for the journey's delivery model.
 * Matches journey to delivery_model and checks that config's mode. Reusable for any journey (e.g. tests, other components).
 */
const getIsCabinOnlyConfiguration = (shop: Shop | undefined, journey: string | undefined): boolean => {
  const deliveryModel = getDeliveryModelFromJourney(journey)
  const config = shop?.shop_resource_type_schedule_configurations?.find((def) => def.delivery_model === deliveryModel)
  return Boolean(config?.mode === ShopResourceTypeScheduleMode.CABIN_ONLY)
}

export { getIsCabinOnlyConfiguration }
